import {take, put, select} from 'redux-saga/effects';
import {openModal, closeModal} from '@computerrock/formation-router/sagas';
import * as serviceAssignmentActionTypes from '../serviceAssignmentActionTypes';
import * as serviceCaseActionTypes from '../../service-cases/serviceCaseActionTypes';
import {requestServiceCaseLock, resetServiceCaseLockTime} from '../../service-cases/sagas/serviceCaseLockRequests';
import ecsAccessControl from '../../ecsAccessControl';
import {ecsFeatures, ecsFeatureActions} from '../../application/ecsFeatures';
import modalIds from '../../modalIds';
import * as applicationActionTypes from '../../application/applicationActionTypes';

/**
 * Update ServiceAssignment
 */
const updateServiceAssignment = function* updateServiceAssignment(params) {
    const {caller, assignmentType, serviceAssignmentLineNo, serviceCaseId, serviceAssignmentData} = params;
    const {serviceManager} = yield select(state => state.application);
    const ecsFlowService = serviceManager.loadService('ecsFlowService');
    const serviceCase = yield select(state => state.serviceCases.serviceCases[serviceCaseId]);
    const isAssignmentUpdateAvailable = ecsAccessControl.grantFeatureAccess(
        ecsFeatures.SERVICE_ASSIGNMENT,
        ecsFeatureActions.UPDATE,
    );
    const isCaseLockUpdateAvailable = ecsAccessControl.grantFeatureAccess(
        ecsFeatures.CASE_LOCK,
        ecsFeatureActions.UPDATE,
    );

    if (!serviceCase || !isAssignmentUpdateAvailable || !isCaseLockUpdateAvailable) return;

    const lockUUID = serviceCase.lock ? serviceCase.lock.lockUUID : null;

    const lockResponse = yield* requestServiceCaseLock(ecsFlowService, serviceCaseId, {
        caller,
        lockUUID,
        lockContext: params.lockContext,
    });

    // if case is not locked or case is lockedBy current user -> allow patch
    if (!lockResponse.error && lockResponse.type === serviceCaseActionTypes.LOCK_SERVICE_CASE_REQUEST_SUCCEEDED) {
        yield* resetServiceCaseLockTime(serviceCaseId, params.lockContext);

        yield put({
            type: serviceAssignmentActionTypes.BATCH_UPDATE_SERVICE_ASSIGNMENT,
            payload: {assignmentType, serviceAssignmentLineNo, serviceCaseId, serviceAssignmentData},
            meta: {caller},
        });

        let batchUpdateServiceAssignmentResponse;
        while (true) {
            const batchUpdateServiceAssignmentAction = yield take(
                serviceAssignmentActionTypes.BATCH_UPDATE_SERVICE_ASSIGNMENT_COMPLETED,
            );
            const {meta = {}} = batchUpdateServiceAssignmentAction;
            if (typeof meta.caller !== 'undefined' && meta.caller !== caller) continue;

            batchUpdateServiceAssignmentResponse = batchUpdateServiceAssignmentAction;
            break;
        }

        if (batchUpdateServiceAssignmentResponse.error) {
            const {message = ''} = batchUpdateServiceAssignmentResponse.payload;
            const parsedMessage = message ? JSON.parse(message) : null;

            if (!parsedMessage || !parsedMessage.errors?.length) return;

            const {errors} = parsedMessage;
            yield* openModal(modalIds.ERROR_MESSAGE_MODAL, {
                actionType: serviceAssignmentActionTypes.UPDATE_SERVICE_ASSIGNMENT_REQUEST_FAILED,
                ...(errors.length > 0
                    && {
                        errors: JSON.stringify(errors),
                    }),
            });

            yield take([
                applicationActionTypes.CANCEL_REQUEST,
            ]);

            yield* closeModal(modalIds.ERROR_MESSAGE_MODAL, {actionType: '', errors: ''});
        }

        return batchUpdateServiceAssignmentResponse;
    }

    return lockResponse;
};

export default updateServiceAssignment;
